module.exports = __webpack_public_path__ + "static/media/documentsFamiliarization.8a3bca0e.svg";